module.exports = __webpack_public_path__ + "files/21c46db001107df97cf04d65b972db1d.png";